<template>
  <div>
    <WdsStack align-center gap-md>
      <WdsSpinner v-if="loading" indeterminate />
      <div @click.stop="approve">
        <slot :loading="loading" />
      </div>
    </WdsStack>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useMutation } from '@vue/apollo-composable'
import { WdsStack, WdsSpinner } from '@worksome/wds-components'
import useApolloError from '@/composables/useApolloError'
import { ApproveTrustedContactMutation } from '@/components/Contacts/CompanyFreelancer/mutations/ApproveTrustedContactMutation'

const props = defineProps({
  trustedContactId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['approved', 'error'])

const loading = ref(false)

const { mutate: mutateApproveTrustedContact, error: approveTrustedContactError } = useMutation(
  ApproveTrustedContactMutation,
  {
    clientId: 'publicApi',
  },
)

const { validationErrors } = useApolloError(approveTrustedContactError)

const approve = () => {
  loading.value = true

  mutateApproveTrustedContact({
    input: {
      id: props.trustedContactId,
    },
  })
    .then(() => {
      emit('approved')
    })
    .catch(() => {
      emit(
        'error',
        Object.values(validationErrors.value).length
          ? Object.values(validationErrors.value)
          : [$t('An error occurred')],
      )
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
